module.exports = __webpack_public_path__ + "static/img/dy2-2.43f6495.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/sougou/dy2-2.png
// module id = 954
// module chunks = 0